export type SeedLoginOption = {
  id: string;
  label: string;
  username: string;
  password: string;
  description?: string;
};

export type SeedLoginGroup = {
  id: string;
  label: string;
  options: SeedLoginOption[];
};

export const SEEDED_LOGIN_PASSWORD = "password123";
export const SEEDED_LOGIN_EMAIL_DOMAIN = "athspire.app";

const withSeededDomain = (localPart: string) => `${localPart}@${SEEDED_LOGIN_EMAIL_DOMAIN}`;

export const SEEDED_LOGIN_GROUPS: SeedLoginGroup[] = [
  {
    id: "core-accounts",
    label: "Core Accounts",
    options: [
      {
        id: "admin",
        label: "Athspire Admin",
        username: withSeededDomain("admin"),
        password: SEEDED_LOGIN_PASSWORD,
        description: "Platform-wide admin access",
      },
      {
        id: "fan",
        label: "Fan User",
        username: "fan@example.com",
        password: SEEDED_LOGIN_PASSWORD,
        description: "Standard supporter account",
      },
      {
        id: "friend",
        label: "Friend User",
        username: "friend@example.com",
        password: SEEDED_LOGIN_PASSWORD,
        description: "Secondary supporter account",
      },
    ],
  },
  {
    id: "school-roles",
    label: "School Roles",
    options: [
      {
        id: "ambassador",
        label: "Brand Ambassador",
        username: withSeededDomain("ambassador"),
        password: SEEDED_LOGIN_PASSWORD,
        description: "School onboarding and oversight",
      },
      {
        id: "saints-hos",
        label: "Saints Head of Sports",
        username: withSeededDomain("saints.hos"),
        password: SEEDED_LOGIN_PASSWORD,
        description: "St Stithians sports workspace",
      },
      {
        id: "saints-head-of-sport",
        label: "Saints Head of Sport",
        username: withSeededDomain("saints.cricket"),
        password: SEEDED_LOGIN_PASSWORD,
        description: "St Stithians cricket leadership",
      },
      {
        id: "saints-coach",
        label: "Saints Coach",
        username: withSeededDomain("saints.coach"),
        password: SEEDED_LOGIN_PASSWORD,
        description: "St Stithians coaching workspace",
      },
      {
        id: "saints-hockey-head-of-sport",
        label: "Saints Hockey Head",
        username: withSeededDomain("saints.hockey"),
        password: SEEDED_LOGIN_PASSWORD,
        description: "St Stithians hockey leadership",
      },
      {
        id: "saints-hockey-coach",
        label: "Saints Hockey Coach",
        username: withSeededDomain("saints.hockey.coach"),
        password: SEEDED_LOGIN_PASSWORD,
        description: "St Stithians hockey coaching workspace",
      },
      {
        id: "bishops-hos",
        label: "Bishops Head of Sports",
        username: withSeededDomain("bishops.hos"),
        password: SEEDED_LOGIN_PASSWORD,
        description: "Bishops sports workspace",
      },
      {
        id: "bishops-head-of-sport",
        label: "Bishops Head of Sport",
        username: withSeededDomain("bishops.cricket"),
        password: SEEDED_LOGIN_PASSWORD,
        description: "Bishops cricket leadership",
      },
      {
        id: "bishops-coach",
        label: "Bishops Coach",
        username: withSeededDomain("bishops.coach"),
        password: SEEDED_LOGIN_PASSWORD,
        description: "Bishops coaching workspace",
      },
      {
        id: "international-hos",
        label: "International Head of Sports",
        username: withSeededDomain("international.hos"),
        password: SEEDED_LOGIN_PASSWORD,
        description: "International Academy sports workspace",
      },
      {
        id: "international-hockey-head-of-sport",
        label: "International Hockey Head",
        username: withSeededDomain("international.hockey"),
        password: SEEDED_LOGIN_PASSWORD,
        description: "International Academy hockey leadership",
      },
      {
        id: "international-hockey-coach",
        label: "International Hockey Coach",
        username: withSeededDomain("international.hockey.coach"),
        password: SEEDED_LOGIN_PASSWORD,
        description: "International Academy hockey coaching workspace",
      },
      {
        id: "westville-hos",
        label: "Westville Head of Sports",
        username: withSeededDomain("westville.hos"),
        password: SEEDED_LOGIN_PASSWORD,
        description: "Westville sports workspace",
      },
      {
        id: "westville-rugby-head-of-sport",
        label: "Westville Rugby Head",
        username: withSeededDomain("westville.rugby"),
        password: SEEDED_LOGIN_PASSWORD,
        description: "Westville rugby leadership",
      },
      {
        id: "westville-rugby-coach",
        label: "Westville Rugby Coach",
        username: withSeededDomain("westville.rugby.coach"),
        password: SEEDED_LOGIN_PASSWORD,
        description: "Westville rugby coaching workspace",
      },
      {
        id: "candidate-hos",
        label: "Candidate Head of Sports",
        username: withSeededDomain("candidate.hos"),
        password: SEEDED_LOGIN_PASSWORD,
        description: "Unassigned head of sports candidate",
      },
      {
        id: "candidate-head-of-sport",
        label: "Candidate Head of Sport",
        username: withSeededDomain("candidate.hosport"),
        password: SEEDED_LOGIN_PASSWORD,
        description: "Unassigned head of sport candidate",
      },
      {
        id: "candidate-coach",
        label: "Candidate Coach",
        username: withSeededDomain("candidate.coach"),
        password: SEEDED_LOGIN_PASSWORD,
        description: "Unassigned coach candidate",
      },
    ],
  },
  {
    id: "athletes",
    label: "Athletes",
    options: [
      {
        id: "siya-kolisi",
        label: "Siya Kolisi",
        username: withSeededDomain("siya.kolisi"),
        password: SEEDED_LOGIN_PASSWORD,
        description: "Player workspace example",
      },
      {
        id: "aiden-markram",
        label: "Aiden Markram",
        username: withSeededDomain("aiden.markram"),
        password: SEEDED_LOGIN_PASSWORD,
        description: "Player workspace example",
      },
      {
        id: "quinton-de-kock",
        label: "Quinton de Kock",
        username: withSeededDomain("quinton.dekock"),
        password: SEEDED_LOGIN_PASSWORD,
        description: "Player workspace example",
      },
    ],
  },
  {
    id: "student-players",
    label: "Student Players",
    options: [
      {
        id: "liam-steyn-student",
        label: "Liam Steyn",
        username: withSeededDomain("liam.steyn.student"),
        password: SEEDED_LOGIN_PASSWORD,
        description: "St Stithians cricket student player",
      },
      {
        id: "jason-naidoo-student",
        label: "Jason Naidoo",
        username: withSeededDomain("jason.naidoo.student"),
        password: SEEDED_LOGIN_PASSWORD,
        description: "St Stithians cricket student player",
      },
      {
        id: "noah-smith-student",
        label: "Noah Smith",
        username: withSeededDomain("noah.smith.student"),
        password: SEEDED_LOGIN_PASSWORD,
        description: "Bishops cricket student player",
      },
      {
        id: "ethan-jacobs-student",
        label: "Ethan Jacobs",
        username: withSeededDomain("ethan.jacobs.student"),
        password: SEEDED_LOGIN_PASSWORD,
        description: "Bishops cricket student player",
      },
      {
        id: "ava-williams-student",
        label: "Ava Williams",
        username: withSeededDomain("ava.williams.student"),
        password: SEEDED_LOGIN_PASSWORD,
        description: "International Academy hockey student player",
      },
      {
        id: "khaya-dlamini-student",
        label: "Khaya Dlamini",
        username: withSeededDomain("khaya.dlamini.student"),
        password: SEEDED_LOGIN_PASSWORD,
        description: "Westville rugby student player",
      },
    ],
  },
];

export const SEEDED_LOGIN_OPTIONS = SEEDED_LOGIN_GROUPS.flatMap((group) => group.options);
